<template>
    <div>
      <HelloWorld />
    </div>
  </template>
  
  <script>
  import HelloWorld from '../../components/HelloWorld.vue'
  
  export default {
    name: 'home',
    components: {
      HelloWorld
    }
  }
  </script>
  
  <style>
  </style>
  